import { $api } from '@service/RequestService';
import { useMutation } from 'react-query';

export const useSearchKeySave = () =>
  useMutation(async (data: any) => {
    const res = await $api.post('/v1/search-key', data);

    return res.data.data;
  });
